import Router from 'vue-router';
import store from '@/store';
import Vue from 'vue';
import { setMeta } from '@/utils';
import { baseURL } from '@/core/constants';
import { RawLocation } from 'vue-router';
import { toTop } from '@/utils';

Vue.use(Router);

const routes = !!store?.getters?.navigation.length ? store?.getters?.navigation : [];

const createRouter = (routerConfig = routes): any => new Router({
  base: `/${baseURL}/`,
  mode: 'history',
  routes: routerConfig,
  scrollBehavior() {
    toTop();
  },
});

const router = createRouter();

router.resetRouter = (newRoutes) => {
  return new Promise((resolve, reject) => {
    try {
      const newRouter = createRouter(newRoutes);
      router.matcher = newRouter.matcher;
      router.options.routes = newRouter.options.routes;
      const { route } = router.resolve(location);
      setMeta({
        title: route?.meta?.meta_title || route?.meta?.link_name,
        description: route?.meta?.meta_description,
      });
      resolve(newRouter);
    } catch (e) {
      reject(e);
    }
  });
};

export const resolveRoutePermissions = (route, next) => {
  if (route.matched.length <= 1 && route?.meta?.hasPermission === false) {
    next('/page-not-found');
  } else if (route.matched.length > 1 && route?.meta?.hasPermission === false) {
    const parentRoute = route.matched[route.matched.length - 2];
    if (parentRoute.redirect.name === route.name) {
      next('/page-not-found');
    } else {
      next({name: parentRoute.name});
    }
  }
};

// auth guard,
router.beforeEach(async (to, from, next) => {
  to.meta.from = from;

  if (!!from.name) {
    // pass first loading app
    // check user required in beforeEnter hook
    resolveRoutePermissions(to, next);
  }

  setMeta({
    title: to?.meta?.meta_title || to?.meta?.link_name,
    description: to?.meta?.meta_description,
  });

  if (!from.name) {
    store.dispatch('fetchData');
    next();
    return;
  }
  next();
});


let pushStack: RawLocation[] = [];

function pushAndSave(loctn: RawLocation, passLocation?: RawLocation, cb?: () => void) {
  if (!!passLocation) {
    pushStack.push(passLocation);
  } else {
    pushStack.push(location.pathname.replace(`/${baseURL}`, ''));
  }
  router.push(loctn);
  if (typeof cb === 'function') {
    cb();
  }
}

function pushBack() {
  router.push(pushStack[0] || '/');
  pushStack = [];
}

Router.prototype.pushAndSave = pushAndSave;
Router.prototype.pushBack = pushBack;
Router.prototype.pushStack = pushStack;

export default router;
